export enum AccountType {
  P = "Player",
  C = "Coach",
}

export enum AccountTypeKey {
  Player = "P",
  Coach = "C",
}

export type Account = {
  [key in AccountTypeKey]: AccountType
}
